import { axiosInstance } from "../utils/ApiClient";

export class RenewalForecastSummaryService {
  constructor(apiClient, showToast) {
    this.apiClient = apiClient || axiosInstance;
    this.showToast = showToast;
  }

  async getRenewalForecastSummary(params = {}) {
    const {
      time_period = "next_quarter",
      custom_days,
      closed_days = 90,
      open_days,
    } = params;

    const queryParams = new URLSearchParams({
      time_period,
      closed_days: closed_days.toString(),
    });

    if (custom_days) {
      queryParams.append("custom_days", custom_days.toString());
    }

    if (open_days) {
      queryParams.append("open_days", open_days.toString());
    }

    const response = await this.apiClient.get(
      `/metrics/renewal-forecast-summary/?${queryParams.toString()}`,
    );

    return response.data;
  }

  // Map time range names to API parameters
  static mapTimeRangeToParams(timeRange) {
    const mappings = {
      "Forecast for this quarter": { time_period: "this_quarter" },
      "Forecast for next quarter": { time_period: "next_quarter" },
      "Forecast for next two quarters": { time_period: "next_2_quarters" },
      "Forecast for next 12 months": { time_period: "next_12_months" },
      "Custom forecast period...": { time_period: "custom" },
      // Map closed deals time ranges to their corresponding API parameters
      "Closed this quarter": { time_period: "this_quarter" },
      "Closed last quarter": { time_period: "last_quarter" },
      "Closed last 2 quarters": { time_period: "last_2_quarters" },
      "Due this quarter": { time_period: "this_quarter" },
      "Due next quarter": { time_period: "next_quarter" },
      "Due next 2 quarters": { time_period: "next_2_quarters" },
      "Due in next 12 months": { time_period: "next_12_months" },
    };

    return mappings[timeRange] || { time_period: "next_quarter" };
  }

  // Helper method to determine if a time range contains closed deals data
  static hasClosedDealsData(timeRange) {
    // Only "Forecast for this quarter" and closed deals time ranges have closed opportunity data
    const closedDataTimeRanges = [
      "Forecast for this quarter",
      "Closed this quarter",
      "Closed last quarter",
      "Closed last 2 quarters",
    ];
    return closedDataTimeRanges.includes(timeRange);
  }
}

export const renewalForecastSummaryService =
  new RenewalForecastSummaryService();
